import { Directive, EventEmitter, Output, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[dropFiles]'
})
export class DropFilesDirective {

  @Input() archivos: any[] = [];
  @Output() overArea: EventEmitter<boolean> = new EventEmitter();
  @Output() showFile: EventEmitter<any> = new EventEmitter();

  constructor() { }

  @HostListener('dragover', ['$event'])
  public onDragEnter(event: any) {
    this.overArea.emit(true);
    this._prevenirDetener(event);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: any) {
    this.overArea.emit(false);
    this._prevenirDetener(event);
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: any) {

    const transferencia = this._getTransfer(event);

    if (!transferencia) {
      return;
    }

    this._extracFiles(transferencia.files);

    
    this.overArea.emit(false);
    this._prevenirDetener(event);

  }

  private _getTransfer(event: any) {
    return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer;
  }

  private _extracFiles(archivosLista: FileList) {

    for (const propiedad in Object.getOwnPropertyNames(archivosLista)) {

      const archivoTemporal = archivosLista[propiedad];

      if (this._fileSuccesLoad(archivoTemporal)) {
          this.showFile.emit(archivoTemporal);
      }
    }
  }

  private _fileSuccesLoad(archivo: File): boolean {

    if (!this._isDropped(archivo.name)) {
      return true;
    } else {
      return false;
    }

  }

  private _prevenirDetener(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  private _isDropped(nombreArchivo: string): boolean {

    for (const archivo of this.archivos) {

      if (archivo.nombreArchivo === nombreArchivo) {
        return true;
      }

    }

    return false;
  }

}
